import { render, staticRenderFns } from "./chat-new.vue?vue&type=template&id=2e4f9cf3&scoped=true"
import script from "./chat-new.vue?vue&type=script&lang=js"
export * from "./chat-new.vue?vue&type=script&lang=js"
import style0 from "./chat-new.vue?vue&type=style&index=0&id=2e4f9cf3&prod&scoped=true&lang=css"
import style1 from "./chat-new.vue?vue&type=style&index=1&id=2e4f9cf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f9cf3",
  null
  
)

export default component.exports